export default {
  dateChangeButton: {
    textAlign: 'right',
    position:'relative',
    zIndex:10,
    '@media(min-width:801px)': {
      paddingBottom:'20px',
      paddingRight: '20px',
      '&:lang(ar)':{
        paddingLeft: '20px',
        textAlign: 'left',
      }
    },
    '& > button':{
      height: '40px',
      padding: '0 15px',
      '& > span':{
        font: "400 14px 'Arial'",
        textTransform:'uppercase'
      },
      '@media(min-width:801px)': {
        width:'auto',
        maxWidth: '245px',
        minWidth: '180px',
      }
    }
  },
  availDatepickerDateButton:{
    position:'fixed',
    bottom:'0',
    left:'0',
    right:'0',
    zIndex:601,
    height:'auto!important',
    padding:'0 !important',
    '& > button':{
      width:'100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    '@media(max-width:800px)': {
      '& > button':{
        '&:hover':{
          background:data=>data.mainColor,
          borderColor:data=>data.mainColor,
          '& > span':{
            color:'#fff!important',
          }
        }
      },
    },
    '@media(min-width:801px)': {
      position:'static',
      padding:'0 20px 10px',
      '& > button':{
        width:'180px'
      },
    }
  }
};
